import type { CSSProperties, ReactNode } from 'react'
import { ConfigProvider } from 'antd'
import { twMerge } from 'tailwind-merge'
import {
  getFeatureTheme,
  getFeatureThemeClassName,
  getFeatureThemeStyle,
  type FeatureThemeKey,
} from '@/lib/productBranding'

type FeatureThemeProviderProps = {
  featureKey: FeatureThemeKey
  withAntd?: boolean
  className?: string
  style?: CSSProperties
  children: ReactNode
}

export default function FeatureThemeProvider({
  featureKey,
  withAntd = false,
  className,
  style,
  children,
}: FeatureThemeProviderProps) {
  const theme = getFeatureTheme(featureKey)
  const themeStyle = getFeatureThemeStyle(theme)

  const content = (
    <div
      className={twMerge(getFeatureThemeClassName(featureKey), className)}
      style={{ ...themeStyle, ...style }}
    >
      {children}
    </div>
  )

  if (!withAntd) return content

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: theme.primary,
        },
      }}
    >
      {content}
    </ConfigProvider>
  )
}
